/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/MFGTransItemGridEditor.ts" />

namespace TabAurous.Production {

    import fld = JobWorkReceiptItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptItemsEditor extends _Ext.MFGTransItemGridEditor<JobWorkReceiptItemsRow> {



        protected getColumnsKey() { return "Production.JobWorkReceiptItems"; }
        protected getDialogType() { return JobWorkReceiptItemsDialog; }
        protected getLocalTextPrefix() { return JobWorkReceiptItemsRow.localTextPrefix; }
        protected form: JobWorkReceiptItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = false;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt; 
        }

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public DepartmentId: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;
        isEditable: boolean;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
            this.isEditable = this.slickGrid.getOptions().editable;
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as JobWorkReceiptDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });
        }
        public Editable() {
            this.isEditable = true;
        }


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons[0].title = "New Transaction";
            return buttons;
        }


    }
}